module.exports = __webpack_public_path__ + "static/media/arrow-left-filled.8168b877.svg";